<template>
  <transition enter-active-class='animated animated3 fadeInRight' leave-active-class='animated animated3 fadeOutRight'>
    <div class="alert message-wrap"  role="alert" v-if="visible">
      <span><i class="iconfont" :class="[alertIcon,alertClass]"></i> {{content}}</span>
    </div>
  </transition>
</template>

<script>

export default {
  props: {
    content: {
      type: String,
      default: '默认信息xxxxxxxx'
    },
    type: {
      type: String,
      default: 'success'
    }
  },
  computed: {
    alertClass() {
      return `alert-${this.type}`;
    },
    alertIcon() {
      switch (this.type) {
        case 'success':
          // eslint-disable-next-line no-unreachable
          return 'icon-chenggong'; break;
        case 'info':
          // eslint-disable-next-line no-unreachable
          return 'icon-chenggong'; break;
        case 'warning':
          // eslint-disable-next-line no-unreachable
          return 'icon-jinggao'; break;
        case 'danger':
          // eslint-disable-next-line no-unreachable
          return 'icon-jinggao'; break;
        default:
          return '未知操作';
      }
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    startTimer() {
      window.setTimeout(() => {
        this.visible = false;
      }, 3000);
    }
  },
  mounted() {
    this.startTimer();
  }
};

</script>

<style scoped lang='less'>
  .message-wrap {
    position: fixed;
    /*margin:auto;*/
    /*left:0;*/
    right:15px;
    display: inline-block;
    top: 15px;
    z-index: 999;
    text-align:center;
    width:220px;
    letter-spacing:2px;
    padding: 16px 24px;
    border: 0;
    background: #FFFFFF;
    border-radius: 4px;
    font-size: 14px;
    //box-shadow: 0 30px 60px 0 rgba(48, 62, 83, 0.24);
    box-shadow: rgba(0, 0, 0, 0.06) 0 0 10px 5px;
    color: #000000;
  }
  .animated1 {
      animation-duration: 0.1s;
      animation-fill-mode: both;
  }
  .animated2 {
      animation-duration: 0.2s;
      animation-fill-mode: both;
  }
  .animated3 {
      animation-duration: 0.3s;
      animation-fill-mode: both;
  }
  .alert-success{
    color: #28A745;
  }
  .alert-danger{
    color: #D73038;
  }
  .alert-warning{
    color: #2A37FE;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/message/index.vue